import { render, staticRenderFns } from "./DealsAndSpecialsRowComponent.vue?vue&type=template&id=1e2680a0&scoped=true&"
import script from "./DealsAndSpecialsRowComponent.vue?vue&type=script&lang=js&"
export * from "./DealsAndSpecialsRowComponent.vue?vue&type=script&lang=js&"
import style0 from "./DealsAndSpecialsRowComponent.vue?vue&type=style&index=0&id=1e2680a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2680a0",
  null
  
)

export default component.exports